module.exports = __webpack_public_path__ + "img/201602-1.7707f04b.jpg";